import React, { useState, useEffect } from 'react';
// @material-ui/core components
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import Pagination from '@material-ui/lab/Pagination';
import { Link } from 'react-router-dom';
import {
  Table,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap';
import { Input } from '@material-ui/core';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import { makeStyles } from '@material-ui/core/styles';
// core components
import { connect } from 'react-redux';
import { getAllVendors, deleteVendor } from '../../store/actions/admin/Admin';
import {  addWalletAmount } from '../../store/actions/vendor/Vendor';

import CardHeader from '../../components/Card/CardHeader.js';
const PAGE_LIMIT = 20
const styles = {
  typo: {
    paddingLeft: '25%',
    marginBottom: '40px',
    position: 'relative'
  },
  note: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    bottom: '10px',
    color: '#c0c1c2',
    display: 'block',
    fontWeight: '400',
    fontSize: '13px',
    lineHeight: '13px',
    left: '0',
    marginLeft: '20px',
    position: 'absolute',
    width: '260px'
  },
  cardCategoryWhite: {
    color: 'rgba(255,255,255,.62)',
    margin: '0',
    fontSize: '14px',
    marginTop: '0',
    marginBottom: '0'
  },
  cardTitleWhite: {
    color: '#FFFFFF',
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: '300',
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: '3px',
    textDecoration: 'none'
  }
};

const useStyles = makeStyles(styles);

const VendorsTable = (props) => {
  const classes = useStyles();
  const [modal, setModal] = useState(false);
  const [modal2, setModal2] = useState(false);
  const [page, setPage] = useState(1);
  const [walletMoney, setWalletMoney] = useState(null)
   const [walletModal, setWalletModal] = useState(false);
   const [itemId, setItemId] = useState(null);
   const toggleWallet = () => setWalletModal(!walletModal);
  const [itemDelete, setItemDelete] = useState(0);


  const toggle = () => setModal(!modal);
  const toggle2 = () => setModal2(!modal2);
  useEffect(() => {
    props.getAllVendors(1);
  }, []);

  const handleDelete = (vendorId) => {
    props.deleteVendor(vendorId).then((data) => {
      if (data) {
        props.getAllVendors(1);
      }
    });
  };
  const handlePagination = (event, value) => {
    setPage(value);
    props.getAllVendors(value);
  };

  const handleWalletMoneyChange = (event) => {
    setWalletMoney(event.target.value)
  }

  const handleWalletMoneyAdd = (id) => {
    props.addWalletAmount(id, walletMoney).then((data) => {
      if (data) {
        setWalletMoney(null)
        // props.getAllUsers(1);
      }
    });
  }

  return (
    <>
      <CardHeader color="primary">
        <h4 className={classes.cardTitleWhite}>
          All vendors - Add, Update, Delete
        </h4>
        <p className={classes.cardCategoryWhite}>
          PNG Images would be better over JPG or imap
        </p>
      </CardHeader>
      <Table hover>
        <thead>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Email</th>
            <th>Icon</th>
            <th>Update</th>
            <th>Wallet Balance</th>
            <th>Add Wallet Balance</th>
            <th>Delete</th>
          </tr>
        </thead>
        <tbody>
          {props.allVendors.map((item, i) => (
            <tr key={item.id}>
              <th scope="row">{i + 1 + (page ? (page - 1) * PAGE_LIMIT : 0)}</th>
              <td>{item.name}</td>
              <td>{item.emailId}</td>
              <td>
                <img
                  src={item.logo}
                  alt={item.name}
                  style={{ height: '100px' }}
                />
              </td>
            
              <td>
                <Link
                  style={{ color: '#000' }}
                  to={'/admin/vendor-edit/' + item.id}
                >
                  <EditIcon />
                </Link>
              </td>
              <td>{item.currency} {item.walletAmount}</td>
              <td>
                <AttachMoneyIcon
                  style={{ cursor: 'pointer' }}
                  onClick={function (event) {
                    toggleWallet();
                    setItemId(item.id);
                  }}
                />
              </td>
              <td>
                <DeleteIcon
                  onClick={function (event) {
                    toggle();
                    setItemDelete(item.id);
                  }}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <Pagination
        count={props.pageCount && props.pageCount - 1}
        color="primary"
        page={page}
        onChange={handlePagination}
      />
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Delete</ModalHeader>
        <ModalBody>Do you really want to delete this Vendor??</ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={function (event) {
              handleDelete(itemDelete);
              toggle();
            }}
          >
            Delete
          </Button>{' '}
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modal2} toggle={toggle2}>
        <ModalHeader toggle={toggle2}>Modify a vendor</ModalHeader>
        <ModalBody></ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={function (event) {
              handleDelete(itemDelete);
              toggle();
            }}
          >
            Delete
          </Button>{' '}
          <Button color="secondary" onClick={toggle2}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={walletModal} toggle={toggleWallet}>
        <ModalHeader toggle={toggleWallet}>Add Wallet Money</ModalHeader>
        <ModalBody>
          <Input type="number" value={walletMoney} onChange={handleWalletMoneyChange} placeholder="Amount" />
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            disabled={!walletMoney}
            onClick={function (event) {
              handleWalletMoneyAdd(itemId);
              toggleWallet();
            }}
          >
            Add
          </Button>{' '}
          <Button color="secondary" onClick={toggleWallet}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
  
      <Link to="/admin/add-vendor">
        <a
          classsName="float-button"
          style={{
            position: 'fixed',
            width: '60px',
            height: '60px',
            bottom: '80px',
            right: '20px',
            backgroundColor: '#A742B9',
            color: '#FFF',
            borderRadius: '50px',
            textAlign: 'center',
            boxShadow: '2px 2px 3px #A742B9'
          }}
        >
          <i
            className="fa fa-plus my-float-button"
            style={{ fontWeight: 600, marginTop: '22px' }}
          >
            {' '}
            Add
          </i>
        </a>{' '}
      </Link>
    </>
  );
};

const mapStateWithProps = (state) => ({
  allVendors: state.admin.allVendors,
  pageCount: state.admin.pageCount
});
const mapDispatchWithProps = (dispatch) => {
  return {
    getAllVendors: (id) => dispatch(getAllVendors(id, PAGE_LIMIT)),
    deleteVendor: (vendorId) => dispatch(deleteVendor(vendorId)),
    addWalletAmount: (id, amount) => dispatch(addWalletAmount(id, amount)),
 
  };
};

export default connect(mapStateWithProps, mapDispatchWithProps)(VendorsTable);
